import { IExportPlugin, PluginType } from '@/version-types';
import { ImageEnhanceController as ImageEnhancePlugin } from './controllers';
import imageEnhancePluginState from './states/image-enhance-state';

const exportPlugin: IExportPlugin = {
    type: PluginType.SYSTEM,
    sort: 10,
    name: 'image-enhance',
    render() {
        return null;
    },
    createInstance({ identity }) {
        return [{ key: 'ImageEnhancePlugin', value: new ImageEnhancePlugin(identity) }];
    },
    createState() {
        return [imageEnhancePluginState];
    },
};

export default exportPlugin;
